export const DEFAULT_ROOM_HEIGHT = 2.5;
export const DEFAULT_IS_HEATED = true;
export const DEFAULT_IS_COOLED = true;
export const DEFAULT_MIN_AREA = 100;
export const DEFAULT_MAX_AREA = 99999;
export const DEFAULT_NUMBER_FORMAT = '1.0-1';
export const DEFAULT_TOTAL_LIVING_AREA = 0;
export const DEFAULT_INCLUDE_TOTAL_BUILDING = false;
